import { useRequest } from 'domain/core/hooks/useRequest';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';

export const useGetJobPostInfoById = (): any => {
  const { data, isLoading, send } = useRequest({
    /* url: `/api/v1/jobPosts/${jobPostId}`, */
    method: ApiMethodsEnum.Get,
    sendOnStart: false,
  });

  const getJobPostInfoById = (jobPostId) => {
    send({}, `/api/v1/jobPosts/${jobPostId}`).then();
  };

  return {
    isLoading,
    getJobPostInfoById,
    data,
  };
};
